import styled from 'styled-components';

export const AddFundSC = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
